import { DatePipe, JsonPipe } from '@angular/common';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';

@Component({
  selector: 'itc-formly-debug',
  template: `
    <mat-expansion-panel
      [(expanded)]="isExpanded"
      (expandedChange)="onExpandedChange($event)"
    >
      <mat-expansion-panel-header>
        <mat-panel-title> Debug </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-card-content>
        <mat-tab-group [(selectedIndex)]="selectedIndex">
          <mat-tab label="Form value">
            <pre>{{ form.value | json }}</pre>
          </mat-tab>
          <mat-tab label="Model" [disabled]="!model">
            <pre>{{ model | json }}</pre>
          </mat-tab>
          <mat-tab label="Submitted" [disabled]="submittedValue === null">
            <p>You just submitted ({{ submittedDate | date: 'short' }}):</p>
            <pre>{{ submittedValue | json }}</pre>
          </mat-tab>
        </mat-tab-group>
      </mat-card-content>
    </mat-expansion-panel>
  `,
  styles: [
    `
      :host {
        margin: 20px;
      }
      .mat-expansion-panel-header {
        background: rgba(0, 0, 0, 0.03);
      }
      .mat-expansion-panel-header.mat-expanded:focus,
      .mat-expansion-panel-header.mat-expanded:hover {
        background: rgba(0, 0, 0, 0.03);
      }
    `,
  ],
  imports: [
    JsonPipe,
    DatePipe,
    MatTabsModule,
    MatCardModule,
    MatExpansionModule,
  ],
})
export class FormlyDebugComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() model: unknown;
  @Input() fields: unknown;

  submittedValue = null;
  isExpanded = false;
  selectedIndex = 0;
  submittedDate = null;

  @ViewChild(MatTabGroup, { static: true }) tabGroup: MatTabGroup;

  ngOnInit() {
    this.isExpanded = sessionStorage.getItem('debug-expanded') === 'true';
  }

  onExpandedChange(isExpanded) {
    sessionStorage.setItem('debug-expanded', isExpanded);
  }
}
